import { d as l, t as b, a as D, b as E, e as M, f as j, h as G, R as x, i as p, j as U, E as B, k as z, l as H, m as k, n as W, o as V, p as N, q as Q, O as $, s as q } from "./resources-DFDnbwuT.mjs";
import { i as A, t as J, a as X, m as Z, B as R, N as Y } from "./callback-DI3dXP55.mjs";
var h;
(function(e) {
  e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.TRACE = 1] = "TRACE", e[e.TRACE2 = 2] = "TRACE2", e[e.TRACE3 = 3] = "TRACE3", e[e.TRACE4 = 4] = "TRACE4", e[e.DEBUG = 5] = "DEBUG", e[e.DEBUG2 = 6] = "DEBUG2", e[e.DEBUG3 = 7] = "DEBUG3", e[e.DEBUG4 = 8] = "DEBUG4", e[e.INFO = 9] = "INFO", e[e.INFO2 = 10] = "INFO2", e[e.INFO3 = 11] = "INFO3", e[e.INFO4 = 12] = "INFO4", e[e.WARN = 13] = "WARN", e[e.WARN2 = 14] = "WARN2", e[e.WARN3 = 15] = "WARN3", e[e.WARN4 = 16] = "WARN4", e[e.ERROR = 17] = "ERROR", e[e.ERROR2 = 18] = "ERROR2", e[e.ERROR3 = 19] = "ERROR3", e[e.ERROR4 = 20] = "ERROR4", e[e.FATAL = 21] = "FATAL", e[e.FATAL2 = 22] = "FATAL2", e[e.FATAL3 = 23] = "FATAL3", e[e.FATAL4 = 24] = "FATAL4";
})(h || (h = {}));
var K = /* @__PURE__ */ function() {
  var e = function(n, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (i[r] = o[r]);
    }, e(n, t);
  };
  return function(n, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(n, t);
    function i() {
      this.constructor = n;
    }
    n.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
  };
}(), tt = (
  /** @class */
  function(e) {
    K(n, e);
    function n(t) {
      var i = e.call(this, t) || this;
      return Object.setPrototypeOf(i, n.prototype), i;
    }
    return n;
  }(Error)
);
function F(e, n) {
  var t, i = new Promise(function(r, s) {
    t = setTimeout(function() {
      s(new tt("Operation timed out."));
    }, n);
  });
  return Promise.race([e, i]).then(function(o) {
    return clearTimeout(t), o;
  }, function(o) {
    throw clearTimeout(t), o;
  });
}
var et = function(e) {
  var n = typeof Symbol == "function" && Symbol.iterator, t = n && e[n], i = 0;
  if (t) return t.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && i >= e.length && (e = void 0), { value: e && e[i++], done: !e };
    }
  };
  throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, nt = function(e, n) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var i = t.call(e), o, r = [], s;
  try {
    for (; (n === void 0 || n-- > 0) && !(o = i.next()).done; ) r.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (t = i.return) && t.call(i);
    } finally {
      if (s) throw s.error;
    }
  }
  return r;
}, rt = (
  /** @class */
  function() {
    function e(n, t, i) {
      this.attributes = {}, this.totalAttributesCount = 0, this._isReadonly = !1;
      var o = i.timestamp, r = i.observedTimestamp, s = i.severityNumber, a = i.severityText, f = i.body, u = i.attributes, c = u === void 0 ? {} : u, d = i.context, g = Date.now();
      if (this.hrTime = b(o ?? g), this.hrTimeObserved = b(r ?? g), d) {
        var L = J.getSpanContext(d);
        L && X(L) && (this.spanContext = L);
      }
      this.severityNumber = s, this.severityText = a, this.body = f, this.resource = n.resource, this.instrumentationScope = t, this._logRecordLimits = n.logRecordLimits, this.setAttributes(c);
    }
    return Object.defineProperty(e.prototype, "severityText", {
      get: function() {
        return this._severityText;
      },
      set: function(n) {
        this._isLogRecordReadonly() || (this._severityText = n);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "severityNumber", {
      get: function() {
        return this._severityNumber;
      },
      set: function(n) {
        this._isLogRecordReadonly() || (this._severityNumber = n);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "body", {
      get: function() {
        return this._body;
      },
      set: function(n) {
        this._isLogRecordReadonly() || (this._body = n);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this.totalAttributesCount - Object.keys(this.attributes).length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setAttribute = function(n, t) {
      return this._isLogRecordReadonly() ? this : t === null ? this : n.length === 0 ? (l.warn("Invalid attribute key: " + n), this) : !A(t) && !(typeof t == "object" && !Array.isArray(t) && Object.keys(t).length > 0) ? (l.warn("Invalid attribute value set for key: " + n), this) : (this.totalAttributesCount += 1, Object.keys(this.attributes).length >= this._logRecordLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, n) ? (this.droppedAttributesCount === 1 && l.warn("Dropping extra attributes."), this) : (A(t) ? this.attributes[n] = this._truncateToSize(t) : this.attributes[n] = t, this));
    }, e.prototype.setAttributes = function(n) {
      var t, i;
      try {
        for (var o = et(Object.entries(n)), r = o.next(); !r.done; r = o.next()) {
          var s = nt(r.value, 2), a = s[0], f = s[1];
          this.setAttribute(a, f);
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          r && !r.done && (i = o.return) && i.call(o);
        } finally {
          if (t) throw t.error;
        }
      }
      return this;
    }, e.prototype.setBody = function(n) {
      return this.body = n, this;
    }, e.prototype.setSeverityNumber = function(n) {
      return this.severityNumber = n, this;
    }, e.prototype.setSeverityText = function(n) {
      return this.severityText = n, this;
    }, e.prototype._makeReadonly = function() {
      this._isReadonly = !0;
    }, e.prototype._truncateToSize = function(n) {
      var t = this, i = this._logRecordLimits.attributeValueLengthLimit;
      return i <= 0 ? (l.warn("Attribute value limit must be positive, got " + i), n) : typeof n == "string" ? this._truncateToLimitUtil(n, i) : Array.isArray(n) ? n.map(function(o) {
        return typeof o == "string" ? t._truncateToLimitUtil(o, i) : o;
      }) : n;
    }, e.prototype._truncateToLimitUtil = function(n, t) {
      return n.length <= t ? n : n.substring(0, t);
    }, e.prototype._isLogRecordReadonly = function() {
      return this._isReadonly && l.warn("Can not execute the operation on emitted log record"), this._isReadonly;
    }, e;
  }()
), T = function() {
  return T = Object.assign || function(e) {
    for (var n, t = 1, i = arguments.length; t < i; t++) {
      n = arguments[t];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, T.apply(this, arguments);
}, it = (
  /** @class */
  function() {
    function e(n, t) {
      this.instrumentationScope = n, this._sharedState = t;
    }
    return e.prototype.emit = function(n) {
      var t = n.context || D.active(), i = new rt(this._sharedState, this.instrumentationScope, T({ context: t }, n));
      this._sharedState.activeProcessor.onEmit(i, t), i._makeReadonly();
    }, e;
  }()
);
function ot() {
  return {
    forceFlushTimeoutMillis: 3e4,
    logRecordLimits: {
      attributeValueLengthLimit: E().OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: E().OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT
    },
    includeTraceContext: !0,
    mergeResourceWithDefaults: !0
  };
}
function ut(e) {
  var n, t, i, o, r, s, a = M();
  return {
    /**
     * Reassign log record attribute count limit to use first non null value defined by user or use default value
     */
    attributeCountLimit: (i = (t = (n = e.attributeCountLimit) !== null && n !== void 0 ? n : a.OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT) !== null && t !== void 0 ? t : a.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && i !== void 0 ? i : G,
    /**
     * Reassign log record attribute value length limit to use first non null value defined by user or use default value
     */
    attributeValueLengthLimit: (s = (r = (o = e.attributeValueLengthLimit) !== null && o !== void 0 ? o : a.OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && r !== void 0 ? r : a.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && s !== void 0 ? s : j
  };
}
var P = function(e, n, t, i) {
  function o(r) {
    return r instanceof t ? r : new t(function(s) {
      s(r);
    });
  }
  return new (t || (t = Promise))(function(r, s) {
    function a(c) {
      try {
        u(i.next(c));
      } catch (d) {
        s(d);
      }
    }
    function f(c) {
      try {
        u(i.throw(c));
      } catch (d) {
        s(d);
      }
    }
    function u(c) {
      c.done ? r(c.value) : o(c.value).then(a, f);
    }
    u((i = i.apply(e, n || [])).next());
  });
}, C = function(e, n) {
  var t = { label: 0, sent: function() {
    if (r[0] & 1) throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(c) {
      return f([u, c]);
    };
  }
  function f(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (i = 1, o && (r = u[0] & 2 ? o.return : u[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, u[1])).done) return r;
      switch (o = 0, r && (u = [u[0] & 2, r.value]), u[0]) {
        case 0:
        case 1:
          r = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (r = t.trys, !(r = r.length > 0 && r[r.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!r || u[1] > r[0] && u[1] < r[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < r[1]) {
            t.label = r[1], r = u;
            break;
          }
          if (r && t.label < r[2]) {
            t.label = r[2], t.ops.push(u);
            break;
          }
          r[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = n.call(e, t);
    } catch (c) {
      u = [6, c], o = 0;
    } finally {
      i = r = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, st = (
  /** @class */
  function() {
    function e(n, t) {
      this.processors = n, this.forceFlushTimeoutMillis = t;
    }
    return e.prototype.forceFlush = function() {
      return P(this, void 0, void 0, function() {
        var n;
        return C(this, function(t) {
          switch (t.label) {
            case 0:
              return n = this.forceFlushTimeoutMillis, [4, Promise.all(this.processors.map(function(i) {
                return F(i.forceFlush(), n);
              }))];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onEmit = function(n, t) {
      this.processors.forEach(function(i) {
        return i.onEmit(n, t);
      });
    }, e.prototype.shutdown = function() {
      return P(this, void 0, void 0, function() {
        return C(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, Promise.all(this.processors.map(function(t) {
                return t.shutdown();
              }))];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), at = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e.prototype.onEmit = function(n, t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e;
  }()
), ct = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(n, t, i) {
      this.resource = n, this.forceFlushTimeoutMillis = t, this.logRecordLimits = i, this.loggers = /* @__PURE__ */ new Map(), this.registeredLogRecordProcessors = [], this.activeProcessor = new at();
    }
    return e;
  }()
), ft = "unknown";
function dt(e, n) {
  var t = n ?? x.empty();
  return e ? x.default().merge(t) : t;
}
var lt = (
  /** @class */
  function() {
    function e(n) {
      n === void 0 && (n = {});
      var t = Z({}, ot(), n), i = dt(t.mergeResourceWithDefaults, n.resource);
      this._sharedState = new ct(i, t.forceFlushTimeoutMillis, ut(t.logRecordLimits)), this._shutdownOnce = new R(this._shutdown, this);
    }
    return e.prototype.getLogger = function(n, t, i) {
      if (this._shutdownOnce.isCalled)
        return l.warn("A shutdown LoggerProvider cannot provide a Logger"), Y;
      n || l.warn("Logger requested without instrumentation scope name.");
      var o = n || ft, r = o + "@" + (t || "") + ":" + ((i == null ? void 0 : i.schemaUrl) || "");
      return this._sharedState.loggers.has(r) || this._sharedState.loggers.set(r, new it({ name: o, version: t, schemaUrl: i == null ? void 0 : i.schemaUrl }, this._sharedState)), this._sharedState.loggers.get(r);
    }, e.prototype.addLogRecordProcessor = function(n) {
      this._sharedState.registeredLogRecordProcessors.length === 0 && this._sharedState.activeProcessor.shutdown().catch(function(t) {
        return l.error("Error while trying to shutdown current log record processor", t);
      }), this._sharedState.registeredLogRecordProcessors.push(n), this._sharedState.activeProcessor = new st(this._sharedState.registeredLogRecordProcessors, this._sharedState.forceFlushTimeoutMillis);
    }, e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? (l.warn("invalid attempt to force flush after LoggerProvider shutdown"), this._shutdownOnce.promise) : this._sharedState.activeProcessor.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.isCalled ? (l.warn("shutdown may only be called once per LoggerProvider"), this._shutdownOnce.promise) : this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      return this._sharedState.activeProcessor.shutdown();
    }, e;
  }()
), ht = function(e, n, t, i) {
  function o(r) {
    return r instanceof t ? r : new t(function(s) {
      s(r);
    });
  }
  return new (t || (t = Promise))(function(r, s) {
    function a(c) {
      try {
        u(i.next(c));
      } catch (d) {
        s(d);
      }
    }
    function f(c) {
      try {
        u(i.throw(c));
      } catch (d) {
        s(d);
      }
    }
    function u(c) {
      c.done ? r(c.value) : o(c.value).then(a, f);
    }
    u((i = i.apply(e, n || [])).next());
  });
}, _t = function(e, n) {
  var t = { label: 0, sent: function() {
    if (r[0] & 1) throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(c) {
      return f([u, c]);
    };
  }
  function f(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (i = 1, o && (r = u[0] & 2 ? o.return : u[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, u[1])).done) return r;
      switch (o = 0, r && (u = [u[0] & 2, r.value]), u[0]) {
        case 0:
        case 1:
          r = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (r = t.trys, !(r = r.length > 0 && r[r.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!r || u[1] > r[0] && u[1] < r[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < r[1]) {
            t.label = r[1], r = u;
            break;
          }
          if (r && t.label < r[2]) {
            t.label = r[2], t.ops.push(u);
            break;
          }
          r[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = n.call(e, t);
    } catch (c) {
      u = [6, c], o = 0;
    } finally {
      i = r = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, pt = (
  /** @class */
  function() {
    function e(n) {
      this._exporter = n, this._shutdownOnce = new R(this._shutdown, this), this._unresolvedExports = /* @__PURE__ */ new Set();
    }
    return e.prototype.onEmit = function(n) {
      var t = this, i, o;
      if (!this._shutdownOnce.isCalled) {
        var r = function() {
          return U._export(t._exporter, [n]).then(function(a) {
            var f;
            a.code !== B.SUCCESS && p((f = a.error) !== null && f !== void 0 ? f : new Error("SimpleLogRecordProcessor: log record export failed (status " + a + ")"));
          }).catch(p);
        };
        if (n.resource.asyncAttributesPending) {
          var s = (o = (i = n.resource).waitForAsyncAttributes) === null || o === void 0 ? void 0 : o.call(i).then(function() {
            return t._unresolvedExports.delete(s), r();
          }, p);
          s != null && this._unresolvedExports.add(s);
        } else
          r();
      }
    }, e.prototype.forceFlush = function() {
      return ht(this, void 0, void 0, function() {
        return _t(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, Promise.all(Array.from(this._unresolvedExports))];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      return this._exporter.shutdown();
    }, e;
  }()
), yt = function(e, n, t, i) {
  function o(r) {
    return r instanceof t ? r : new t(function(s) {
      s(r);
    });
  }
  return new (t || (t = Promise))(function(r, s) {
    function a(c) {
      try {
        u(i.next(c));
      } catch (d) {
        s(d);
      }
    }
    function f(c) {
      try {
        u(i.throw(c));
      } catch (d) {
        s(d);
      }
    }
    function u(c) {
      c.done ? r(c.value) : o(c.value).then(a, f);
    }
    u((i = i.apply(e, n || [])).next());
  });
}, mt = function(e, n) {
  var t = { label: 0, sent: function() {
    if (r[0] & 1) throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(c) {
      return f([u, c]);
    };
  }
  function f(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (i = 1, o && (r = u[0] & 2 ? o.return : u[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, u[1])).done) return r;
      switch (o = 0, r && (u = [u[0] & 2, r.value]), u[0]) {
        case 0:
        case 1:
          r = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (r = t.trys, !(r = r.length > 0 && r[r.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!r || u[1] > r[0] && u[1] < r[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < r[1]) {
            t.label = r[1], r = u;
            break;
          }
          if (r && t.label < r[2]) {
            t.label = r[2], t.ops.push(u);
            break;
          }
          r[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = n.call(e, t);
    } catch (c) {
      u = [6, c], o = 0;
    } finally {
      i = r = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, gt = (
  /** @class */
  function() {
    function e(n, t) {
      var i, o, r, s;
      this._exporter = n, this._finishedLogRecords = [];
      var a = E();
      this._maxExportBatchSize = (i = t == null ? void 0 : t.maxExportBatchSize) !== null && i !== void 0 ? i : a.OTEL_BLRP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = (o = t == null ? void 0 : t.maxQueueSize) !== null && o !== void 0 ? o : a.OTEL_BLRP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = (r = t == null ? void 0 : t.scheduledDelayMillis) !== null && r !== void 0 ? r : a.OTEL_BLRP_SCHEDULE_DELAY, this._exportTimeoutMillis = (s = t == null ? void 0 : t.exportTimeoutMillis) !== null && s !== void 0 ? s : a.OTEL_BLRP_EXPORT_TIMEOUT, this._shutdownOnce = new R(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (l.warn("BatchLogRecordProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.onEmit = function(n) {
      this._shutdownOnce.isCalled || this._addToBuffer(n);
    }, e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      return yt(this, void 0, void 0, function() {
        return mt(this, function(n) {
          switch (n.label) {
            case 0:
              return this.onShutdown(), [4, this._flushAll()];
            case 1:
              return n.sent(), [4, this._exporter.shutdown()];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._addToBuffer = function(n) {
      this._finishedLogRecords.length >= this._maxQueueSize || (this._finishedLogRecords.push(n), this._maybeStartTimer());
    }, e.prototype._flushAll = function() {
      var n = this;
      return new Promise(function(t, i) {
        for (var o = [], r = Math.ceil(n._finishedLogRecords.length / n._maxExportBatchSize), s = 0; s < r; s++)
          o.push(n._flushOneBatch());
        Promise.all(o).then(function() {
          t();
        }).catch(i);
      });
    }, e.prototype._flushOneBatch = function() {
      var n = this;
      return this._clearTimer(), this._finishedLogRecords.length === 0 ? Promise.resolve() : new Promise(function(t, i) {
        F(n._export(n._finishedLogRecords.splice(0, n._maxExportBatchSize)), n._exportTimeoutMillis).then(function() {
          return t();
        }).catch(i);
      });
    }, e.prototype._maybeStartTimer = function() {
      var n = this;
      this._timer === void 0 && (this._timer = setTimeout(function() {
        n._flushOneBatch().then(function() {
          n._finishedLogRecords.length > 0 && (n._clearTimer(), n._maybeStartTimer());
        }).catch(function(t) {
          p(t);
        });
      }, this._scheduledDelayMillis), z(this._timer));
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e.prototype._export = function(n) {
      var t = this, i = function() {
        return U._export(t._exporter, n).then(function(r) {
          var s;
          r.code !== B.SUCCESS && p((s = r.error) !== null && s !== void 0 ? s : new Error("BatchLogRecordProcessor: log record export failed (status " + r + ")"));
        }).catch(p);
      }, o = n.map(function(r) {
        return r.resource;
      }).filter(function(r) {
        return r.asyncAttributesPending;
      });
      return o.length === 0 ? i() : Promise.all(o.map(function(r) {
        var s;
        return (s = r.waitForAsyncAttributes) === null || s === void 0 ? void 0 : s.call(r);
      })).then(i, p);
    }, e;
  }()
), Lt = /* @__PURE__ */ function() {
  var e = function(n, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (i[r] = o[r]);
    }, e(n, t);
  };
  return function(n, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(n, t);
    function i() {
      this.constructor = n;
    }
    n.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
  };
}(), wt = (
  /** @class */
  function(e) {
    Lt(n, e);
    function n(t, i) {
      var o = e.call(this, t, i) || this;
      return o._onInit(i), o;
    }
    return n.prototype.onShutdown = function() {
      typeof document > "u" || (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, n.prototype._onInit = function(t) {
      var i = this;
      (t == null ? void 0 : t.disableAutoFlushOnDocumentHide) === !0 || typeof document > "u" || (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && i.forceFlush();
      }, this._pageHideListener = function() {
        i.forceFlush();
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, n;
  }(gt)
), vt = function(e) {
  var n = typeof Symbol == "function" && Symbol.iterator, t = n && e[n], i = 0;
  if (t) return t.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && i >= e.length && (e = void 0), { value: e && e[i++], done: !e };
    }
  };
  throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, I = function(e, n) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var i = t.call(e), o, r = [], s;
  try {
    for (; (n === void 0 || n-- > 0) && !(o = i.next()).done; ) r.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (t = i.return) && t.call(i);
    } finally {
      if (s) throw s.error;
    }
  }
  return r;
};
function Et(e, n) {
  var t = N(n);
  return {
    resourceLogs: Rt(e, t)
  };
}
function Tt(e) {
  var n, t, i = /* @__PURE__ */ new Map();
  try {
    for (var o = vt(e), r = o.next(); !r.done; r = o.next()) {
      var s = r.value, a = s.resource, f = s.instrumentationScope, u = f.name, c = f.version, d = c === void 0 ? "" : c, g = f.schemaUrl, L = g === void 0 ? "" : g, w = i.get(a);
      w || (w = /* @__PURE__ */ new Map(), i.set(a, w));
      var O = u + "@" + d + ":" + L, v = w.get(O);
      v || (v = [], w.set(O, v)), v.push(s);
    }
  } catch (S) {
    n = { error: S };
  } finally {
    try {
      r && !r.done && (t = o.return) && t.call(o);
    } finally {
      if (n) throw n.error;
    }
  }
  return i;
}
function Rt(e, n) {
  var t = Tt(e);
  return Array.from(t, function(i) {
    var o = I(i, 2), r = o[0], s = o[1];
    return {
      resource: H(r),
      scopeLogs: Array.from(s, function(a) {
        var f = I(a, 2), u = f[1];
        return {
          scope: k(u[0].instrumentationScope),
          logRecords: u.map(function(c) {
            return Ot(c, n);
          }),
          schemaUrl: u[0].instrumentationScope.schemaUrl
        };
      }),
      schemaUrl: void 0
    };
  });
}
function Ot(e, n) {
  var t, i, o;
  return {
    timeUnixNano: n.encodeHrTime(e.hrTime),
    observedTimeUnixNano: n.encodeHrTime(e.hrTimeObserved),
    severityNumber: e.severityNumber,
    severityText: e.severityText,
    body: W(e.body),
    attributes: bt(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    flags: (t = e.spanContext) === null || t === void 0 ? void 0 : t.traceFlags,
    traceId: n.encodeOptionalSpanContext((i = e.spanContext) === null || i === void 0 ? void 0 : i.traceId),
    spanId: n.encodeOptionalSpanContext((o = e.spanContext) === null || o === void 0 ? void 0 : o.spanId)
  };
}
function bt(e) {
  return Object.keys(e).map(function(n) {
    return V(n, e[n]);
  });
}
var xt = {
  serializeRequest: function(e) {
    var n = Et(e, {
      useHex: !0,
      useLongBits: !1
    }), t = new TextEncoder();
    return t.encode(JSON.stringify(n));
  },
  deserializeResponse: function(e) {
    var n = new TextDecoder();
    return JSON.parse(n.decode(e));
  }
}, At = /* @__PURE__ */ function() {
  var e = function(n, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (i[r] = o[r]);
    }, e(n, t);
  };
  return function(n, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(n, t);
    function i() {
      this.constructor = n;
    }
    n.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
  };
}(), Pt = (
  /** @class */
  function(e) {
    At(n, e);
    function n(t) {
      return t === void 0 && (t = {}), e.call(this, Q(t, xt, "v1/logs", { "Content-Type": "application/json" })) || this;
    }
    return n;
  }($)
);
function Ct({
  batchLogs: e,
  url: n,
  devMode: t,
  httpHeaders: i = {},
  ...o
}) {
  const r = It(o), s = new Pt({
    url: n,
    headers: {
      ...i
    }
  });
  return e ? r.addLogRecordProcessor(new wt(s)) : r.addLogRecordProcessor(
    new pt(s)
  ), r;
}
function It(e) {
  return new lt({
    resource: q(e)
  });
}
var _ = /* @__PURE__ */ ((e) => (e.ERROR = "ERROR", e.WARN = "WARN", e.INFO = "INFO", e.DEBUG = "DEBUG", e.TRACE = "TRACE", e.DEFAULT = "DEFAULT", e))(_ || {});
function St({
  serviceName: e,
  url: n,
  version: t,
  devMode: i,
  ...o
}) {
  return i ? () => console : (r = "") => {
    const a = Ct({
      url: n,
      serviceName: e,
      version: t,
      ...o
    }).getLogger(r);
    return Ut(a);
  };
}
function Ut(e) {
  return {
    log(...n) {
      m(
        e,
        y(_.DEFAULT, h.INFO, ...n)
      );
    },
    error(...n) {
      m(
        e,
        y(_.ERROR, h.ERROR, ...n)
      );
    },
    debug(...n) {
      m(
        e,
        y(_.DEBUG, h.DEBUG, ...n)
      );
    },
    warn(...n) {
      m(
        e,
        y(_.WARN, h.WARN, ...n)
      );
    },
    info(...n) {
      m(
        e,
        y(_.INFO, h.INFO, ...n)
      );
    },
    trace(...n) {
      m(
        e,
        y(_.TRACE, h.TRACE, ...n)
      );
    }
  };
}
function y(e, n, ...t) {
  const i = {
    attributes: {},
    body: void 0,
    severityNumber: n,
    severityText: e
  };
  return i.body = t == null ? void 0 : t.map((o) => o instanceof Error ? JSON.stringify(o, Object.getOwnPropertyNames(o)) : o), i;
}
function m(e, n) {
  if (n !== void 0)
    return e.emit(n);
}
export {
  _ as S,
  St as c,
  It as g,
  Ct as l
};
